import { FlexProps } from "@chakra-ui/layout";
import React from "react";
import Card from "../Card";

type ClientCardProps = FlexProps;
const ClientCard: React.FC<ClientCardProps> = ({ ...rest }) => {
  return (
    <Card
      w="8%"
      h="100%"
      bgSize="contain"
      bgRepeat="no-repeat"
      bgPosition="center"
      borderRadius="20px"
      boxShadow="dark-lg"
      {...rest}
    ></Card>
  );
};

export default ClientCard;
